import { 
  WAIT_INIT_MODELS, INIT_MODELS_SUCCESS, INIT_MODELS_FAIL, DELETE_MODEL, DELETE_MODEL_SUCCESS, DELETE_MODEL_FAIL,  // Main List
  FORWARD_MODEL_DETAIL, GET_MODEL_DETAIL, GET_MODEL_DETAIL_SUCCESS, CLOSE_DETAIL_STATUS, SET_MODEL_DETAIL, SAVE_MODEL_FORM, SAVE_MODEL_FORM_SUCCESS, SAVE_MODEL_FORM_FAIL  // Form
} from '../actions/maintenance/index';

const doAction = (state, action) => {
  switch (action.type) {
    case WAIT_INIT_MODELS:
      return {
        ...state,
        status: WAIT_INIT_MODELS,
        models: [],
        errMsg: null,
        modelDetail: {
          loading: true
        },
        loading: true
      }
    case INIT_MODELS_SUCCESS:
      return {
        ...state,
        models: action.params.models,
        status: INIT_MODELS_SUCCESS,
        modelDetail: {
          loading: true
        },
        loading: false
      }
    case INIT_MODELS_FAIL:
      return {
        ...state,
        models: [],
        errMsg: action.params.errMsg,
        status: INIT_MODELS_FAIL,
        loading: true
      }
    case SET_MODEL_DETAIL:
      return {
        ...state,
        status: SET_MODEL_DETAIL,
        modelDetail: action.params.modelDetail,
      }
    case FORWARD_MODEL_DETAIL:
      return {
        ...state,
        status: FORWARD_MODEL_DETAIL,
        displayDetail: true, 
        modelDetail: {
          loading: false
        }
      }
    case GET_MODEL_DETAIL:
      return {
        ...state,
        displayDetail: true,
        status: GET_MODEL_DETAIL,
        modelDetail: {
          loading: true
        }
      }
    case GET_MODEL_DETAIL_SUCCESS:
      const modelDetail = action.params.modelDetail;
      let newModelDetail = {
        errMsg: 'get detail fail'
      };
      if (modelDetail && Object.keys(modelDetail).length > 0) {
        newModelDetail = Object.assign({}, modelDetail);
        newModelDetail['loading'] = false;
      }

      return {
        ...state,
        status: GET_MODEL_DETAIL_SUCCESS,        
        modelDetail: newModelDetail
      }
    case CLOSE_DETAIL_STATUS:
      return {
        ...state,
        displayDetail: false,
        modelDetail: {
          loading: true
        }
      }
    case SAVE_MODEL_FORM:
      return {
        ...state,
        status: SAVE_MODEL_FORM,
        errMsg: null,
        modelDetail: {
          ...state.modelDetail,
          loading: true
        },
      }
    case SAVE_MODEL_FORM_SUCCESS:
      return {
        ...state,
        status: SAVE_MODEL_FORM_SUCCESS,
        modelDetail: {
          loading: true
        },
      }
    case SAVE_MODEL_FORM_FAIL:
      return {
        ...state,
        status: SAVE_MODEL_FORM_FAIL,
        errMsg: action.params.errMsg,
        modelDetail: {
          ...state.modelDetail,
          loading: false
        },
      }
    case DELETE_MODEL:
      return {
        ...state,
        status: DELETE_MODEL,        
        popLoading: true
      }
    case DELETE_MODEL_SUCCESS:
      return {
        ...state,
        status: DELETE_MODEL_SUCCESS,
        models: action.params.models,
        popLoading: false
      }
    case DELETE_MODEL_FAIL:
      return {
        ...state,
        status: DELETE_MODEL_FAIL,
        errMsg: action.params.errMsg,
        popLoading: false
      }
  default:
      return state;
    }
}

const maintenanceReducers = (state = {
  models: [],
  errMsg: null,
  status: WAIT_INIT_MODELS,
  displayDetail: false,
  modelDetail: {
    loading: true
  },
  loading: true,
  popLoading: false
}, action) => {
  switch (action.type) {
    default:
      return doAction(state, action);
  }
}

export default maintenanceReducers;